import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/play.svg';

export const IconPlay = createIconComponent(Icon);
